// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"0df2a22b","160":"cdf4418a","208":"4cdf1866","293":"09bf9a53","453":"9a02b154","516":"f87a5281","519":"bf95c2e3","917":"08d1392d","946":"945df2c7"}[chunkId] + ".chunk.js";
};